<template>
  <div id="pageRoot">
    <p class="textBase appearAnimationB" id="text01" style="z-index: 6">
      Escribe el nombre del personaje en el cartel.
    </p>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      class="appearAnimationB"
      style="z-index: 7"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
      class="appearAnimationB"
      style="z-index: 7"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="inputField03"
      class="appearAnimationB"
      style="z-index: 7"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="4"
      id="inputField04"
      class="appearAnimationB"
      style="z-index: 7"
    />

    <div
      class="basicItem01"
      id="tag01"
      style="
        z-index: 7;
        background-image: url(/pages/img/sordo/svgPage70Tag.svg);
        background-size: cover;
      "
    >
      <p class="textBase" id="tag01Text">VENANCIO</p>
    </div>
    <div
      class="basicItem01"
      id="tag02"
      style="
        z-index: 7;
        background-image: url(/pages/img/sordo/svgPage70Tag.svg);
        background-size: cover;
      "
    >
      <p class="textBase" id="tag02Text">DON FITO</p>
    </div>
    <div
      class="basicItem01"
      id="tag03"
      style="
        z-index: 7;
        background-image: url(/pages/img/sordo/svgPage70Tag.svg);
        background-size: cover;
      "
    >
      <p class="textBase" id="tag03Text">DOÑA ENRIQUETA</p>
    </div>
    <div
      class="basicItem01"
      id="tag04"
      style="
        z-index: 7;
        background-image: url(/pages/img/sordo/svgPage70Tag.svg);
        background-size: cover;
      "
    >
      <p class="textBase" id="tag04Text">GOROSITO, EL CARNICERO</p>
    </div>

    <img
      src="/pages/img/sordo/svgPage70FrontFixed.svg"
      class="appearAnimationB"
      id="frontFixed"
      style="z-index: 6"
    />

    <!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
    <img
      src="/pages/img/sordo/svgPage70Title.svg"
      class="appearAnimationB"
      id="title"
      style="z-index: 5"
    />
    <div id="backgroundDogWrapper" class="popUpAnimation" style="z-index: 4">
      <img
        src="/pages/img/sordo/svgPage70Dog.svg"
        class="pageElement bouncingItem"
        id="backgroundDog"
      />
    </div>
    <img
      src="/pages/img/sordo/svgPage70DonFito.svg"
      class="pageElement popUpAnimation"
      id="backgroundDonFito"
      style="z-index: 4"
    />
    <img
      src="/pages/img/sordo/svgPage70Carnicero.svg"
      class="pageElement popUpAnimation"
      id="backgroundCarnicero"
      style="z-index: 4"
    />
    <img
      src="/pages/img/sordo/svgPage70Palmerita.svg"
      class="pageElement popUpAnimation"
      id="backgroundPalmerita"
      style="z-index: 3"
    />
    <img
      src="/pages/img/sordo/svgPage70RedHouse.svg"
      class="pageElement popUpAnimation"
      id="backgroundRedHouse"
      style="z-index: 3"
    />
    <img
      src="/pages/img/sordo/svgPage70MiddleAgeWoman.svg"
      class="pageElement popUpAnimation"
      id="backgroundMiddleAgeWoman"
      style="z-index: 3"
    />
    <div id="backgroundCloudWrapper" class="popUpAnimation" style="z-index: 2">
      <img
        src="/pages/img/sordo/svgPage70Cloud.svg"
        class="pageElement slideItem"
        id="backgroundCloud"
      />
    </div>
    <img
      src="/pages/img/sordo/svgPage70YellowHouse.svg"
      class="pageElement popUpAnimation"
      id="backgroundYellowHouse"
      style="z-index: 2"
    />
    <img
      src="/pages/img/sordo/svgPage70BackgroundBottomRect.svg"
      class="pageElement"
      id="backgroundBottomRect"
      style="z-index: 1"
    />
    <img
      src="/pages/img/sordo/svgPage70BackgroundTopRect.svg"
      class="pageElement"
      id="backgroundTopRect"
      style="z-index: 0"
    />
    <!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
  </div>
</template>
<style scoped>
.textBase {
  margin: 0px;
  z-index: 3;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 33px;
  color: #000000;
}
.popUpAnimation {
  opacity: 0;
  transform: translateY(120px) scale(0);

  animation-name: backgroundYellowHouse-animation;
  animation-duration: 0.3s;
  animation-timing-function: cubic-bezier(0.07, 0.42, 0.48, 1.45);
  animation-fill-mode: forwards;
}
.tagsSVG {
  width: 100%;
  height: 100%;
}
#tag01 {
  position: absolute;
  width: 127.95px;
  height: 43.54px;
  left: 278px;
  top: 641.68px;
}
#tag01Text {
  position: absolute;
  width: 100px;
  height: 27px;
  left: 9px;
  top: 5.32px;

  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 27px;

  color: #ffffff;
}
#tag02 {
  position: absolute;
  width: 118.46px;
  height: 43.14px;
  left: 428px;
  top: 640.68px;
}
#tag02Text {
  position: absolute;
  width: 94px;
  height: 27px;
  left: 9px;
  top: 4.32px;

  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 27px;

  color: #ffffff;
}
#tag03 {
  position: absolute;
  width: 192.02px;
  height: 42.98px;
  left: 569px;
  top: 641.68px;
}
#tag03Text {
  position: absolute;
  width: 173px;
  height: 27px;
  left: 7px;
  top: 3.32px;

  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 27px;

  color: #ffffff;
}
#tag04 {
  position: absolute;
  width: 274.41px;
  height: 45.5px;
  left: 356px;
  top: 693.1px;
}
#tag04Text {
  position: absolute;
  width: 268px;
  height: 29px;
  left: 2px;
  top: 6.9px;

  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 27px;
  text-align: center;

  color: #ffffff;
}

#inputField01 {
  position: absolute;
  width: 252px;
  left: 356px;
  top: 107px;
  font-size: 25px;
  animation-delay: 1.1s;
}
#inputField02 {
  position: absolute;
  width: 259px;
  left: 372px;
  top: 495px;
  font-size: 25px;
  animation-delay: 1.1s;
}
#inputField03 {
  position: absolute;
  width: 267px;
  left: 218px;
  top: 581px;
  font-size: 25px;
  animation-delay: 1.1s;
}
#inputField04 {
  position: absolute;
  width: 267px;
  left: 516px;
  top: 581px;
  font-size: 25px;
  animation-delay: 1.1s;
}
#text01 {
  /* Escribe el nombre del personaje en el cartel */
  position: absolute;
  width: 536px;
  height: 32px;
  left: 353px;
  top: 63px;
  animation-delay: 1.1s;
  color: #ffffff;
}
#frontFixed {
  position: absolute;
  width: 582px;
  height: 558.68px;
  left: 219px;
  top: 70px;
  animation-delay: 1.1s;
}
#title {
  position: absolute;
  left: 4.39%;
  right: 60.94%;
  top: 1.3%;
  bottom: 94.71%;
  animation-delay: 1s;
}
#backgroundCarnicero {
  position: absolute;
  width: 111px;
  height: 194px;
  left: 688px;
  top: 381.68px;
  animation-delay: 0.8s;
}
#backgroundDonFito {
  position: absolute;
  width: 97px;
  height: 195px;
  left: 208px;
  top: 378.68px;
  animation-delay: 0.7s;
}
#backgroundDogWrapper {
  position: absolute;
  width: 159px;
  height: 91px;
  left: 420px;
  top: 376.68px;
  animation-delay: 0.9s;
}
#backgroundDog {
  position: absolute;
  width: 159px;
  height: 91px;
}
#backgroundMiddleAgeWoman {
  position: absolute;
  width: 76.79px;
  height: 100px;
  left: 211px;
  top: 51px;
  animation-delay: 0.8s;
}
#backgroundPalmerita {
  position: absolute;
  width: 129.5px;
  height: 174.9px;
  left: 8px;
  top: 379px;
  animation-delay: 0.2s;
}

#backgroundRedHouse {
  position: absolute;
  width: 387px;
  height: 367px;
  left: 478px;
  top: 185.68px;
  animation-delay: 0.5s;
}

#backgroundCloud {
  position: absolute;
  width: 361px;
  height: 185px;
}
#backgroundCloudWrapper {
  position: absolute;
  width: 361px;
  height: 185px;
  left: 608px;
  top: 106px;
  animation-delay: 0.6s;
}

#backgroundYellowHouse {
  position: absolute;
  width: 426.12px;
  height: 411.02px;
  left: 99px;
  top: 141px;
  animation-delay: 0.3s;
}

@keyframes backgroundYellowHouse-animation {
  from {
    opacity: 0;
    transform: translateY(120px) scale(0);
  }
  to {
    opacity: 1;
    transform: translateY(0px) scale(1);
  }
}

#backgroundBottomRect {
  position: absolute;
  width: 918px;
  height: 234px;
  left: 27px;
  top: 526px;
  animation-name: backgroundBottomRect-animation;
  animation-duration: 0.3s;
  animation-timing-function: cubic-bezier(0.07, 0.42, 0.61, 0.99);
}

@keyframes backgroundBottomRect-animation {
  from {
    transform: translateY(120px);
  }
  to {
    transform: translateY(0px);
  }
}

#backgroundTopRect {
  position: absolute;
  width: 895px;
  height: 532px;
  left: 32px;
  top: 0px;
  animation-name: backgroundTopRect-animation;
  animation-duration: 0.5s;
  animation-timing-function: cubic-bezier(0.07, 0.42, 0.61, 0.99);
}

@keyframes backgroundTopRect-animation {
  from {
    transform: translateY(-120px);
  }
  to {
    transform: translateY(0px);
  }
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p70/V47.mp4"]
    }
  }
}
</script>